






















import {Component, Vue} from 'vue-property-decorator';
import {ALL_LINKS, Link, LinkType} from '../storage/links';

@Component
export default class AppFooter extends Vue {
    protected get links(): Link[] {
        return ALL_LINKS;
    }
}
